import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.onScroll = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScroll);

    this.lastScrollY = window.scrollY;
  }

  disconnect() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const { scrollY } = window;

    const scrollDelta = scrollY - this.lastScrollY;

    const scrollDirection = scrollDelta > 0 ? 1 : -1;

    if (scrollDirection === 1 && scrollY > 60 && scrollY < 360) {
      this.element.classList.add('nav-hide');
    } else if (scrollDirection === 1 && scrollY >= 360) {
      this.element.classList.replace('nav-hide', 'nav-show');
    } else if (scrollDirection === -1 && scrollY >= 360) {
      this.element.classList.replace('nav-show', 'nav-hide');
    } else if (scrollDirection === -1 && scrollY < 360) {
      this.element.classList.remove('nav-show');
      this.element.classList.remove('nav-hide');
    }

    this.lastScrollY = scrollY;
  }
}
